import get from 'lodash/get';
import keyBy from 'lodash/keyBy';

function validateOxygenActions(caseConf, nodeInfo) {
  const oxygenActionNodes = nodeInfo.actionNodes.filter(
    (node) => get(node, 'data.action.type') === 'OXYGEN'
  );
  const oxygens = (caseConf._oxygens || []).filter(o => get(o, 'options.enabled'));
  const oxygensById = keyBy(oxygens, 'id');
  const errors = [];
  const warnings = [];

  oxygenActionNodes.forEach((oxygenActionNode) => {
    if (!oxygens.length) {
      warnings.push({
        message: 'Oxygen is not enabled',
        category: 'caseLogic',
        field: 'caseLogicDescription',
        id: oxygenActionNode.id,
        metadata: {
          nodeId: oxygenActionNode.id,
          scope: 'control',
        },
      });
    }
    get(oxygenActionNode, 'data.action.routes', []).forEach((oxygenRoute) => {
      const oxygen = oxygensById[oxygenRoute];

      if (!oxygen || !oxygen.options.enabled) {
        const label = get(oxygen, 'name.en', oxygenRoute);
        warnings.push({
          message: `${label} is used in case logic but is not enabled`,
          category: 'oxygen',
          field: '_oxygens',
          id: oxygenRoute,
          metadata: {
            nodeId: oxygenActionNode.id,
            oxygenKey: oxygenActionNode.data.action.id,
            scope: 'control',
          },
        });
        warnings.push({
          message: `${label} type is not enabled`,
          category: 'caseLogic',
          field: 'caseLogicDescription',
          id: oxygenActionNode.id,
          metadata: {
            nodeId: oxygenActionNode.id,
            oxygenKey: oxygenActionNode.data.action.id,
            scope: 'control',
          },
        });
      }
    });
  });
  return {
    errors,
    warnings,
  };
}

export default validateOxygenActions;
